module.exports = __webpack_public_path__ + "static/media/dish_card1.553e12fd.png";